export default "__VITE_ASSET__423c437f__"